const PREFIX = 'doggos_view_v1:'
export const VIEW_CACHE_MAX_AGE = 24 * 60 * 60 * 1000

export function currentViewScope() {
  if (typeof window === 'undefined') return ''
  try {
    const token = window.localStorage.getItem('doggos_l')
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const claims = JSON.parse(
      window.atob(part + '='.repeat((4 - (part.length % 4)) % 4))
    )
    const account = claims.accountId || claims.listingId || claims.user_id
    if (
      !claims.user_id ||
      !account ||
      (claims.exp && claims.exp * 1000 <= Date.now())
    )
      return ''
    return `${encodeURIComponent(claims.user_id)}:${encodeURIComponent(
      account
    )}`
  } catch {
    return ''
  }
}

export function readViewCache(name, scope = currentViewScope()) {
  if (!scope || typeof window === 'undefined') return null
  try {
    const value = JSON.parse(
      window.localStorage.getItem(PREFIX + scope + ':' + name)
    )
    if (
      !value ||
      value.scope !== scope ||
      !Number.isFinite(value.savedAt) ||
      Date.now() - value.savedAt > VIEW_CACHE_MAX_AGE ||
      value.savedAt > Date.now()
    )
      return null
    return value.data
  } catch {
    return null
  }
}

export function writeViewCache(name, data, scope = currentViewScope()) {
  if (!scope || scope !== currentViewScope() || typeof window === 'undefined')
    return
  try {
    window.localStorage.setItem(
      PREFIX + scope + ':' + name,
      JSON.stringify({ scope, savedAt: Date.now(), data })
    )
  } catch {
    /* Storage denial or quota must never prevent loading live data. */
  }
}

export function clearViewCaches() {
  if (typeof window === 'undefined') return
  try {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => window.localStorage.removeItem(key))
    window.localStorage.removeItem('doggos_hotel_calendar_v1')
  } catch {
    /* Best effort in restricted browsers. */
  }
}

/** The full rendered calendar, including imported stays; revive JSON dates. */
export function readCalendarDisplaySnapshot() {
  const saved = readViewCache('calendar-display')
  if (!Array.isArray(saved)) return null
  const events = saved.map(event => ({ ...event, start: new Date(event?.start), end: new Date(event?.end) }))
  if (events.some(event => !Number.isFinite(event.start.getTime()) || !Number.isFinite(event.end.getTime()))) return null
  return events
}

/** Revalidate each calendar source independently; one failed source cannot hide fresh data. */
export function mergeRevalidatedCalendarSnapshot(snapshot, fresh, calendarReady, activityReady) {
  if (!Array.isArray(snapshot)) return fresh
  return [
    ...(calendarReady ? fresh : snapshot).filter(event => !event.importProfile),
    ...(activityReady ? fresh : snapshot).filter(event => event.importProfile),
  ]
}

/** Older snapshots may contain unread text. Never restore that server-only state. */
export function cachedConversationDisplay(row) {
  return { ...row, unreadCount: 0, sublineText: row.unreadCount > 0 ? '' : row.sublineText }
}
